export class DataError extends Error {
  public origin?: string;
  public dataType?: string;

  constructor(origin?: string, dataType?: string) {
    super(`Unable to perform action due to missing ${dataType + " "}data (origin: ${origin ?? "unknown"})`);
    this.origin = origin;
    this.dataType = dataType;
  }
}

export interface ServerErrorData {
  secondaryStatusCode?: string;
  message?: string;
  mdcKey?: string;
}

export class ServerError extends Error {
  public code = 0;
  public cause?: Error;
  public data?: ServerErrorData;

  constructor(code: number, cause?: Error, data?: ServerErrorData) {
    super(
      `A network error occurred (${code}), please try again later` +
        (data
          ? ` (${[data?.secondaryStatusCode, data?.mdcKey]
            .filter(Boolean)
            .join(" ")})`
          : "")
    );
    this.code = code;
    this.cause = cause;
    this.data = data;
  }
}
